import axios from 'axios'
import { env } from '@/settings/env'

export const apiAtlas = axios.create({
  baseURL: env.API_ATLAS_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

apiAtlas.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('@athenas:token') // Ou de onde você estiver armazenando o token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

apiAtlas.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response.status === 401) {
      // Lidar com o token inválido, expirado ou ausente
      // Redirecionar para a página de login, por exemplo
    }
    return Promise.reject(error)
  }
)
